import React from 'react';
import { Box, Button, Card, LinearProgress, Stack, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Link } from 'react-router-dom';
import { pagePaths } from 'routes/paths';
import { Goal } from '../mockStats';

interface TodayGoalCardProps {
  goal: Goal;
}

const TodayGoalCard: React.FC<TodayGoalCardProps> = ({ goal }) => {
  const pct = Math.min(100, Math.round((goal.current / goal.target) * 100));
  const done = goal.current >= goal.target;

  return (
    <Card sx={{ height: '100%' }}>
      <Stack spacing={2.5} sx={{ height: '100%' }}>
        <Stack direction={'row'} alignItems={'center'} spacing={1}>
          <Typography color={'text.secondary'} fontWeight={700}>
            {'Сьогодні'}
          </Typography>
          {done && (
            <Stack direction={'row'} alignItems={'center'} spacing={0.5}>
              <CheckCircleOutlineIcon
                sx={{ color: 'primary.aqua', fontSize: 18 }}
              />
              <Typography
                color={'primary.aqua'}
                fontWeight={700}
                variant={'body2'}
              >
                {'Готово'}
              </Typography>
            </Stack>
          )}
        </Stack>

        <Box>
          <Typography variant={'h3'} sx={{ lineHeight: 1.1 }}>
            {done
              ? 'Ціль виконано'
              : `${goal.current} / ${goal.target} ${goal.unit}`}
          </Typography>
          <Typography color={'text.secondary'} sx={{ mt: 0.5 }}>
            {done
              ? 'Можеш зробити бонусний раунд або повернутися завтра.'
              : 'Повтори слова, щоб зберегти серію днів.'}
          </Typography>
        </Box>

        <Box>
          <LinearProgress
            value={pct}
            variant={'determinate'}
            sx={{
              bgcolor: 'primary.purple',
              borderRadius: 10,
              height: 10,
              '& .MuiLinearProgress-bar': {
                bgcolor: done ? 'primary.aqua' : 'primary.main',
              },
            }}
          />
          <Stack direction={'row'} justifyContent={'space-between'} sx={{ mt: 1 }}>
            <Typography color={'text.secondary'} variant={'body2'}>
              {goal.period === 'DAILY' ? 'Денна ціль' : 'Ціль періоду'}
            </Typography>
            <Typography color={'primary.main'} fontWeight={700} variant={'body2'}>
              {`${pct}%`}
            </Typography>
          </Stack>
        </Box>

        <Box sx={{ mt: 'auto' }}>
          <Button
            component={Link}
            startIcon={<PlayArrowIcon />}
            to={'/' + pagePaths.learning}
            fullWidth
          >
            {done ? 'Бонусний раунд' : 'Продовжити вправи'}
          </Button>
        </Box>
      </Stack>
    </Card>
  );
};

export default TodayGoalCard;
